'use client';

import { ScreenContent, ScreenTabBar } from '@/screen';
import { ErrorMessage } from '@/components/ErrorMessage';

// WHY: без своей границы ошибка страницы вики уходит в global-error, а он заменяет весь корень — в Mini App вместе с
// приложением под слоем вики; граница стоит под layout вики, поэтому экран ошибки остаётся в его каркасе
export default function WikiError({ retry }: { retry: () => void }) {
  return (
    <>
      <ScreenTabBar />
      <ScreenContent className="flex items-center justify-center p-4">
        <ErrorMessage onRetry={retry} />
      </ScreenContent>
    </>
  );
}
